import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative bg-white border border-gray-200 dark:border-gray-700 dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_3 = { class: "bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between rounded-t-lg" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md"
}
const _hoisted_6 = { class: "text-sm text-red-600 dark:text-red-400" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = ["type"]
const _hoisted_10 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_11 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_16 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_21 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-5 h-5"
}
const _hoisted_22 = { class: "border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3 rounded-b-lg" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, reactive, computed, watch } from 'vue'
import { useBrand } from '@/composables/brand/useBrand'

interface Props {
  isOpen: boolean
  loading?: boolean
  error?: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangePasswordModal',
  props: {
    isOpen: { type: Boolean },
    loading: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { brandColors } = useBrand()

const showCurrentPassword = ref(false)
const showNewPassword = ref(false)
const showConfirmPassword = ref(false)

const form = reactive({
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const isFormValid = computed(() => {
  return form.currentPassword &&
         form.newPassword &&
         form.newPassword.length >= 8 &&
         form.confirmPassword &&
         form.newPassword === form.confirmPassword &&
         form.currentPassword !== form.newPassword
})

// Reset form state
const resetForm = () => {
  form.currentPassword = ''
  form.newPassword = ''
  form.confirmPassword = ''
  showCurrentPassword.value = false
  showNewPassword.value = false
  showConfirmPassword.value = false
}

// Handle form submission
const handleSubmit = () => {
  if (!isFormValid.value) return

  // Validate passwords match
  if (form.newPassword !== form.confirmPassword) {
    return
  }

  // Validate password length
  if (form.newPassword.length < 8) {
    return
  }

  // Validate new password is different from current
  if (form.currentPassword === form.newPassword) {
    return
  }

  emit('submit', {
    currentPassword: form.currentPassword,
    newPassword: form.newPassword
  })
}

// Watch for modal open to reset form
watch(() => props.isOpen, (isOpen) => {
  if (isOpen) resetForm()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center mr-3",
                        style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary + '20' })
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          class: "w-5 h-5",
                          style: _normalizeStyle({ color: _unref(brandColors).primary })
                        }, _cache[9] || (_cache[9] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ]), 4))
                      ], 4),
                      _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Change Password ", -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[11] || (_cache[11] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-6"
                  }, [
                    (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.error), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", {
                        for: "currentPassword",
                        class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                      }, [
                        _createTextVNode(" Current Password "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          id: "currentPassword",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.currentPassword) = $event)),
                          type: showCurrentPassword.value ? 'text' : 'password',
                          class: "w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 dark:bg-black dark:text-white",
                          style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      }),
                          placeholder: "Enter your current password",
                          required: "",
                          autocomplete: "current-password"
                        }, null, 12, _hoisted_9), [
                          [_vModelDynamic, form.currentPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showCurrentPassword.value = !showCurrentPassword.value)),
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                        }, [
                          (showCurrentPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[12] || (_cache[12] = [
                                _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                                _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                                _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[13] || (_cache[13] = [
                                _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                                  "clip-rule": "evenodd"
                                }, null, -1)
                              ])))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", {
                        for: "newPassword",
                        class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                      }, [
                        _createTextVNode(" New Password "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          id: "newPassword",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.newPassword) = $event)),
                          type: showNewPassword.value ? 'text' : 'password',
                          class: "w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 dark:bg-black dark:text-white",
                          style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      }),
                          placeholder: "Enter your new password",
                          required: "",
                          minlength: "8",
                          autocomplete: "new-password"
                        }, null, 12, _hoisted_14), [
                          [_vModelDynamic, form.newPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (showNewPassword.value = !showNewPassword.value)),
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                        }, [
                          (showNewPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[15] || (_cache[15] = [
                                _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                                _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                                _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[16] || (_cache[16] = [
                                _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                                  "clip-rule": "evenodd"
                                }, null, -1)
                              ])))
                        ])
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Password must be at least 8 characters long ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[21] || (_cache[21] = _createElementVNode("label", {
                        for: "confirmPassword",
                        class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                      }, [
                        _createTextVNode(" Confirm New Password "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          id: "confirmPassword",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.confirmPassword) = $event)),
                          type: showConfirmPassword.value ? 'text' : 'password',
                          class: "w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-2 dark:bg-black dark:text-white",
                          style: _normalizeStyle({ 
                        borderColor: _unref(brandColors).primary,
                        '--tw-ring-color': _unref(brandColors).primary,
                        'outline': 'none'
                      }),
                          placeholder: "Confirm your new password",
                          required: "",
                          autocomplete: "new-password"
                        }, null, 12, _hoisted_19), [
                          [_vModelDynamic, form.confirmPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (showConfirmPassword.value = !showConfirmPassword.value)),
                          class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                        }, [
                          (showConfirmPassword.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[19] || (_cache[19] = [
                                _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                                _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                                _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[20] || (_cache[20] = [
                                _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                                  "clip-rule": "evenodd"
                                }, null, -1)
                              ])))
                        ])
                      ])
                    ])
                  ], 32),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancel ", 8, _hoisted_23),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleSubmit,
                      disabled: _ctx.loading || !isFormValid.value,
                      class: "px-4 py-2 text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center",
                      style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _cache[22] || (_cache[22] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Changing Password...' : 'Change Password'), 1)
                    ], 12, _hoisted_24)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})